import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="bg-[#2B3324] text-[#F7F3EA]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-display text-2xl font-light tracking-tight">
            Kenneth Nathanael <span className="text-[#C5A059]">Lukman</span>{" "}
            <span className="text-sm align-top text-[#F7F3EA]/60">LLC</span>
          </div>
          <p className="mt-6 text-[#F7F3EA]/70 leading-relaxed max-w-md text-sm">
            Independent property consulting for private landlords across the
            United Kingdom&apos;s most desirable addresses. Written mandates,
            live-market data, and the operator&apos;s discipline — placed at
            the service of the owner.
          </p>
          <div className="mt-8 space-y-3 text-sm text-[#F7F3EA]/80">
            <a
              href="mailto:info@kenneth-llc.com"
              data-testid="footer-email"
              className="flex items-center gap-3 hover:text-[#C5A059] transition-colors"
            >
              <Mail className="w-4 h-4 text-[#C5A059]" />
              info@kenneth-llc.com
            </a>
            <a
              href="tel:+17622269357"
              data-testid="footer-phone"
              className="flex items-center gap-3 hover:text-[#C5A059] transition-colors"
            >
              <Phone className="w-4 h-4 text-[#C5A059]" />
              +1 (762) 226-9357
            </a>
          </div>

          <div className="mt-6 pt-6 border-t border-[#F7F3EA]/10">
            <div className="text-[11px] tracking-[0.2em] uppercase text-[#C5A059]/80 mb-2">
              Registered Office
            </div>
            <div className="flex items-start gap-3 text-sm text-[#F7F3EA]/80 leading-relaxed">
              <MapPin className="w-4 h-4 text-[#C5A059] mt-0.5 shrink-0" />
              <span data-testid="footer-registered-office">
                30 N Gould St Ste R<br />
                Sheridan, WY 82801, USA
              </span>
            </div>
          </div>
        </div>

        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-[#C5A059] mb-5">
            Explore
          </div>
          <ul className="space-y-3 text-sm text-[#F7F3EA]/80">
            <li>
              <Link
                to="/"
                data-testid="footer-link-home"
                className="hover:text-[#C5A059] transition-colors"
              >
                Home
              </Link>
            </li>
            <li>
              <a
                href="/#apartments"
                data-testid="footer-link-apartments"
                className="hover:text-[#C5A059] transition-colors"
              >
                Apartments
              </a>
            </li>
            <li>
              <Link
                to="/consultancy"
                data-testid="footer-link-consultancy"
                className="hover:text-[#C5A059] transition-colors"
              >
                Consultancy
              </Link>
            </li>
            <li>
              <a
                href="/#about"
                data-testid="footer-link-about"
                className="hover:text-[#C5A059] transition-colors"
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="/#contact"
                data-testid="footer-link-contact"
                className="hover:text-[#C5A059] transition-colors"
              >
                Contact
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs tracking-[0.2em] uppercase text-[#C5A059] mb-5">
            Speak With Us
          </div>
          <p className="text-sm text-[#F7F3EA]/70 leading-relaxed">
            Every enquiry is answered within one business day. Introductory
            calls are offered without fee or commitment.
          </p>
          <a
            href="/consultancy"
            data-testid="footer-cta"
            className="inline-block mt-5 border border-[#C5A059] text-[#C5A059] hover:bg-[#C5A059] hover:text-[#2B3324] transition-all duration-300 px-5 py-2.5 rounded-md text-sm font-medium"
          >
            Explore Services
          </a>
        </div>
      </div>

      <div className="border-t border-[#F7F3EA]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[#F7F3EA]/50">
          <div>
            © {new Date().getFullYear()} Kenneth Nathanael Lukman LLC. All
            rights reserved.
          </div>
          <div>            Crafted for the discerning property owner.</div>
        </div>
      </div>
    </footer>
  );
}
